<div class="root-container">
    <ng-content select="[section-title]"></ng-content>
    <ng-content select="[section-subtitle]"></ng-content>

    <div class="body">
        <ng-content></ng-content>
    </div>
</div>
